<template>
  <div class="confirmation main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Setor {{ sector != null ? sector.name : '' }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="header-info">
          <b-col cols="12">
            <div class="box-cj">

              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table main-table-cj">
                  <thead>
                  <tr>
                    <th>Data / Hora</th>
                    <th>Paciente</th>
                    <th>Profissional</th>
                    <th>Agenda</th>
                    <th>Status</th>
                    <th></th>
                    <th></th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                    <template v-if="sector != null">
                      <tr v-for="directing in sector.pending_directings" :key="directing.id">
                        <td class="align-middle">{{ moment(directing.start_datetime).format('DD/MM HH:mm') }}</td>
                        <td class="align-middle">
                          {{ directing.patient.name }}<br/>
                          <small>
                            {{ directing.patient.cellphone }}
                          </small>
                        </td>
                        <td class="align-middle">{{ directing.appointment.professional.name }}</td>
                        <td class="align-middle">{{ directing.appointment.agenda.name }}</td>
                        <td class="align-middle" v-html="getStatusTag(directing)"></td>
                        <td class="align-middle"><b-button v-if="directing.call_datetime == null" variant="success" @click="callDirecting(directing)">Chamar</b-button></td>
                        <td class="align-middle"><b-button variant="primary" @click="showDirectingModal(directing)">Encaminhar</b-button></td>
                        <td class="align-middle"><b-button variant="danger" @click="endDirecting(directing)">Encerrar</b-button></td>
                      </tr>
                      <tr v-if="sector.pending_directings.length == 0">
                        <td colspan="8" class="align-middle text-center">Não há nenhum encaminhamento pendente neste setor</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <b-modal id="directing-modal" class="directing-modal" :modalClass="'directing-modal'" @hidden="resetDirectingModal">
      <template slot="modal-header">
        Encaminhar paciente
      </template>
      <template slot="default">
        <validation-observer ref="directingForm" v-slot="{ invalid }">
          <b-row class="mb-2">
            <b-col>
              <label class="cj-label">Setor</label>
              <validation-provider name="setor" :rules="{ required: true }" v-slot="{ errors }">
                <multiselect v-model="directingForm.directing_sector" :options="directingSectorOptions" track-by="name" label="name" :preselectFirst="false" :allowEmpty="false" :showLabels="false" :searchable="true" @select="sectorSelected" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row v-if="directingForm.directing_sector != null && directingSectorProfessionalOptions.length > 0">
            <b-col>
              <label class="cj-label">Profissional (opcional)</label>
              <validation-provider name="profissional" :rules="{ required: false }" v-slot="{ errors }">
                <multiselect v-model="directingForm.professional" :options="directingSectorProfessionalOptions" track-by="name" label="name" :preselectFirst="false" :allowEmpty="true" :showLabels="false" :searchable="true" placeholder="Selecione" :class="{ 'error': errors.length > 0 }">
                  <template slot="clear">
                    <div class="multiselect__clear" v-if="directingForm.professional != null" @mousedown.prevent.stop="directingForm.professional = null"></div>
                  </template>
                </multiselect>
                <span class="cj-error">{{ errors[0] }}</span>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </template>
      <template slot="modal-footer">
        <b-button size="sm" @click="$bvModal.hide('directing-modal')">Fechar</b-button>
        <b-button size="sm" variant="success" @click="saveDirecting">Encaminhar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        leavingPage: false,
        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        module: 'directing-sectors',

        canPerformAction: true,

        sector: null,

        directingSectorOptions: [],
        directingSectorProfessionals: {},
        directingSectorProfessionalOptions: [],

        directingForm: {
          id: null,
          agenda_id: null,
          directing_sector: null,
          professional: null,
        }
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.canSee = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY')?true:this.helpers.checkPermission(this.module, 'can_remove');

      if(this.canSee == false || !this.user.person.client.directing_enabled) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }
      this.getDirectingSectorData();
    },
    methods: {
      async getDirectingSectorData() {
        this.eventBus.$emit('IS_LOADING', true);
        await this.api.getDirectingSectorData(this.$route.params.id).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.loadDirectingSectorData(res.data);

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Directing Sector', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos carregar seu setor! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Directing Sector', err.response);
        });
      },
      loadDirectingSectorData(data) {
        this.sector = data.directing_sector;
        this.directingSectorOptions = [];
        this.directingSectorProfessionals = {};
        data.directing_sectors.forEach(directingSector => {
          this.directingSectorOptions.push({value: directingSector.id, name: directingSector.name});
          this.directingSectorProfessionals[directingSector.id] = [];
          directingSector.professionals.forEach(professional => {
            this.directingSectorProfessionals[directingSector.id].push({value: professional.id, name: professional.name, agenda_ids: professional.agendas.map(agenda => agenda.id)});
          });
        });
      },
      async callDirecting(directing) {
        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);
        this.api.callDirecting(directing.directing_sector_id, directing.id).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          this.$swal('Parabéns...', 'Paciente chamado com sucesso!', 'success');

          this.loadDirectingSectorData(res.data);

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Call Directing', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          let response = err.response;
          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos chamar este paciente! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

          this.$swal('Ops...', message, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Call Directing', response);
        });
      },
      showDirectingModal(directing) {
        this.directingForm.id = directing.id;
        this.directingForm.agenda_id = directing.appointment.agenda_id;
        this.$bvModal.show('directing-modal');
      },
      resetDirectingModal() {
        this.directingForm = {
          id: null,
          agenda_id: null,
          directing_sector: null,
          professional: null
        };
      },
      sectorSelected(selectedOption) {
        this.directingSectorProfessionalOptions = this.directingSectorProfessionals[selectedOption.value].filter(professional => professional.agenda_ids.indexOf(this.directingForm.agenda_id) >= 0).sort((a, b) => a.name.localeCompare(b.name));
        if(this.directingForm.professional != null && !this.directingSectorProfessionalOptions.find(professional => professional.value == this.directingForm.professional.value)) {
          this.directingForm.professional = null;
        }
      },
      async saveDirecting() {
        if(!this.canPerformAction)
          return false;
        const isValid = await this.$refs.directingForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }
        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);

        let directingData = {
          id: this.directingForm.id,
          professional_id: this.directingForm.professional != null ? this.directingForm.professional.value : null
        };
        await this.api.createDirecting(this.directingForm.directing_sector.value, directingData).then(res => {
          if(this.leavingPage) {
            return;
          }
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          this.$swal('Parabéns...', 'Paciente encaminhado com sucesso!', 'success');

          this.loadDirectingSectorData(res.data);
          this.$bvModal.hide('directing-modal');

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Create Directing', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          console.log(6);
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let response = err.response;
          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos encaminhar este paciente! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

          this.$swal('Ops...', message, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Create Directing', response);
        });
      },
      async endDirecting(directing) {
        await this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.api.endDirecting(directing.directing_sector_id, directing.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Parabéns...', 'Encaminhamento encerrado com sucesso!', 'success');

              this.loadDirectingSectorData(res.data);

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response End Directing', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              let response = err.response;
              let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos encerrar este encaminhamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

              this.$swal('Ops...', message, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error End Directing', response);
            });
          }
        });
      },
      getStatusTag(directing) {
        let color = '#0F94D8',
            text = 'Aguardando',
            calledBy = '';
        if(directing.call_datetime != null) {
          color = '#28CD6A';
          text = 'Chamado(a)';
          calledBy = '<small class="d-block mt-2">por '+directing.called_by_person.name+'</small>';
        }

        return '<span class="tag" style="background-color: '+color+';">'+text+'</span>'+calledBy;
      }
    },
    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .confirmation {
    padding: 20px 0;

    .header-info {
      p {
        margin: 0;
      }

      .info {

      }

      .value {
        font-size: 32px;
        color: $linkWater;
      }
    }

    .tag {
      width: 100%;
      padding: 5px 15px;
      color: #ffffff;
      border-radius: 15px;
    }

    .box-cj {
      .content {
        th {
          color: $cadetGray;
          border-top: 0;
        }

        tbody {
          color: $waikawaGray;

          .line-add {
            padding: 10px 0;
          }

          tr:nth-child(even) {
            background-color: $whisper;
          }

          tr:nth-child(odd) {
          }
        }
      }
    }
  }
</style>
